import { render } from "./AudienceCreateForm.vue?vue&type=template&id=31a748c6"
import script from "./AudienceCreateForm.vue?vue&type=script&lang=js"
export * from "./AudienceCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__